import React, { useEffect } from 'react'

const HomeInternalPage = ({ html }) => {
  useEffect(() => {
    document.title = 'Careers'
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <span dangerouslySetInnerHTML={{ __html: html }}></span>
    </>
  )
}

export default HomeInternalPage
